import React from 'react';
import { ScrollView } from 'react-native';
import { green } from '@/shared/styles/colors';
import OnboardingHeader from '@/shared/components/navigation/OnboardingHeader';
import HeroSection from '@/components/event-landing/HeroSection';
import NormalShowSection from '@/components/event-landing/NormalShowSection';
import FeaturedStylists from '@/components/event-landing/FeaturedStylists';
import FinalCallout from '@/components/event-landing/FinalCallout';
import { eventConfig } from '@/components/event-landing/constants';
import styled from '@emotion/native';
import Footer from '@/shared/components/Footer';
import { useAuth } from '@/services/auth/AuthProvider';
import SentryService from '@/services/sentry/Sentry.service';
import { router } from 'expo-router';

export default function EventLanding() {
  const { logIn } = useAuth();

  const onStylistLogin = async () => {
    try {
      await logIn();
    } catch (error) {
      SentryService.captureError('Event landing: Failed to log in:', error);
    }
  };

  const onLogoPress = () => {
    router.push('/');
  };

  return (
    <Container showsVerticalScrollIndicator={false}>
      <OnboardingHeader
        onPress={onStylistLogin}
        authText="Log In"
        onLogoPress={onLogoPress}
      />
      <HeroSection
        config={eventConfig.hero}
        backgroundImage={require('@/assets/images/event-landing/HeroImg.png')}
      />
      <NormalShowSection config={eventConfig.normalShow} />
      <FeaturedStylists config={eventConfig.featuredStylists} />
      <FinalCallout config={eventConfig.finalCallout} />
      <Footer />
    </Container>
  );
}

const Container = styled(ScrollView)({
  flex: 1,
  backgroundColor: green,
});
